"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleFilterOptions = exports.availabilityTopicFilter = void 0;
const enums_1 = require("../../enums");
const availabilityTopicFilter = (hierarchy) => {
    var _a;
    const manufacturers = (_a = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.manufacturers) === null || _a === void 0 ? void 0 : _a.filter(function f(o) {
        var _a;
        if ((_a = o === null || o === void 0 ? void 0 : o.topics) === null || _a === void 0 ? void 0 : _a.some(({ path }) => path === '/kanal/10klikk'))
            return true;
        else if (o === null || o === void 0 ? void 0 : o.series)
            return (o.series = o.series.filter(f)).length;
        else if (o === null || o === void 0 ? void 0 : o.models)
            return (o.models = o.models.filter(f)).length;
        else if (o === null || o === void 0 ? void 0 : o.salesPackages)
            return (o.salesPackages = o.salesPackages.filter(f)).length;
    });
    return {
        manufacturers,
    };
};
exports.availabilityTopicFilter = availabilityTopicFilter;
const getMakeOptions = (hierarchy) => {
    var _a;
    const options = (_a = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.manufacturers) === null || _a === void 0 ? void 0 : _a.map(({ name }) => ({
        label: name,
        value: (0, enums_1.getMakeCodeByName)(name),
    }));
    return [{ label: 'Velg et merke', value: null }, ...(options !== null && options !== void 0 ? options : [])];
};
const getModelSeriesOptions = (hierarchy, make) => {
    var _a, _b;
    const options = (_b = (_a = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.manufacturers) === null || _a === void 0 ? void 0 : _a.find(({ name }) => (0, enums_1.getMakeCodeByName)(name) === make)) === null || _b === void 0 ? void 0 : _b.series.map(({ name }) => ({ label: name, value: name.toLowerCase() }));
    return [{ label: 'Velg en modellserie', value: null }, ...(options !== null && options !== void 0 ? options : [])];
};
const getModelOptions = (hierarchy, make, modelSeries) => {
    var _a, _b, _c, _d, _e;
    const options = (_e = (_d = (_c = (_b = (_a = hierarchy === null || hierarchy === void 0 ? void 0 : hierarchy.manufacturers) === null || _a === void 0 ? void 0 : _a.find(({ name }) => (0, enums_1.getMakeCodeByName)(name) === make)) === null || _b === void 0 ? void 0 : _b.series) === null || _c === void 0 ? void 0 : _c.find(({ name }) => name.toLowerCase() === modelSeries)) === null || _d === void 0 ? void 0 : _d.models) === null || _e === void 0 ? void 0 : _e.map(({ name }) => ({ label: name, value: name.toLowerCase() }));
    return [{ label: 'Velg en modell', value: null }, ...(options !== null && options !== void 0 ? options : [])];
};
const getVehicleFilterOptions = (hierarchy, make = null, modelSeries = null, filterOnTopics = false) => {
    const filteredHierarchy = filterOnTopics ? (0, exports.availabilityTopicFilter)(hierarchy) : hierarchy;
    const makeOptions = getMakeOptions(filteredHierarchy);
    const modelSeriesOptions = getModelSeriesOptions(filteredHierarchy, make);
    const modelOptions = getModelOptions(filteredHierarchy, make, modelSeries);
    return {
        makeOptions,
        modelSeriesOptions,
        modelOptions,
    };
};
exports.getVehicleFilterOptions = getVehicleFilterOptions;
//# sourceMappingURL=option.js.map